import React, { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchRateSubProcessOptions,
  fetchRateItemOptions,
  getRateSubProcessOptions,
  getRateItemOptions,
} from "../../features/parties/processRatesSlice";
import { localizedProcessName } from "../../lib/utils";
import { t } from "../../locales";
import { ProcessDefinitionProps } from "../../types/processDefinition";
import { ProcessRateProps, ProcessRateRow } from "../../types/processRate";
import ProcessRateEditor from "./ProcessRateEditor";

type Props = {
  processDefinitions: ProcessDefinitionProps[];
  rates: ProcessRateProps[];
  onSaveTab: (processDefinitionId: number, rows: ProcessRateRow[]) => void;
  saving: boolean;
};

const ProcessRateList = ({ processDefinitions, rates, onSaveTab, saving }: Props) => {
  const dispatch = useAppDispatch();
  const subProcessOptions = useAppSelector(getRateSubProcessOptions);
  const itemOptions = useAppSelector(getRateItemOptions);
  const [activeTab, setActiveTab] = useState<string>(
    processDefinitions[0] ? String(processDefinitions[0].id) : ""
  );

  useEffect(() => {
    dispatch(fetchRateItemOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!activeTab && processDefinitions[0]) {
      setActiveTab(String(processDefinitions[0].id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processDefinitions]);

  useEffect(() => {
    if (activeTab) {
      dispatch(fetchRateSubProcessOptions({ process_definition_id: Number(activeTab) }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  if (processDefinitions.length === 0) {
    return (
      <p className="text-sm text-gray-500 text-center py-8">
        {t.processRates.noProcessesAssigned}
      </p>
    );
  }

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab}>
      <TabsList className="flex-wrap h-auto">
        {processDefinitions.map((d) => (
          <TabsTrigger key={d.id} value={String(d.id)}>
            {localizedProcessName(d)}
          </TabsTrigger>
        ))}
      </TabsList>

      {processDefinitions.map((d) => (
        <TabsContent key={d.id} value={String(d.id)}>
          <ProcessRateEditor
            rows={rates.filter((r) => r.process_definition_id === d.id)}
            subProcessOptions={subProcessOptions}
            itemOptions={itemOptions}
            saving={saving}
            onSave={(rows) => onSaveTab(d.id, rows)}
          />
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default ProcessRateList;
